// Lesson 5 — Calling Chi + discard reading. Chi is legal only from the player to
// the learner's left, which for the human (seat 0) means the discarder must be
// seat 3. Seats 1 and 2 are pass-through bots that shed their lone honours, then
// seat 3's uniquely-worst tile is an ISOLATED 1-Bamboo (usefulness −0.5, its only
// terminal, no honours, every other tile ≥ 0) — so it discards exactly the tile
// the learner needs to complete 1-2-3 of Bamboo. All bot discards here are
// deterministic by a wide usefulness margin, independent of the seeded noise.

import { createDealBuilder, fillerBot } from './deckBuilder.js';
import type { LessonScript } from '../types.js';

const b = createDealBuilder();

const sou2 = b.suit('sou', 2);
const sou3 = b.suit('sou', 3);
const white = b.honor('white');

const human = [
  sou2,
  sou3,
  white,
  b.suit('man', 4),
  b.suit('man', 5),
  b.suit('man', 6),
  b.suit('pin', 4),
  b.suit('pin', 5),
  b.suit('pin', 6),
  b.suit('pin', 8),
  b.suit('pin', 9),
  b.suit('man', 8),
  b.suit('sou', 6),
];

const seat1 = fillerBot(b, 'east', [['sou', 4], ['sou', 7], ['pin', 1], ['man', 7]]);
const seat2 = fillerBot(b, 'south', [['man', 1], ['man', 4], ['pin', 4], ['pin', 7]]);
// Seat 3 has no honours; its only terminal (1-Bamboo) sits isolated as the worst
// tile, so it is discarded for the learner's Chi.
const seat3 = [
  b.suit('sou', 1),
  ...b.run('man', 2),
  ...b.run('man', 6),
  ...b.run('pin', 4),
  b.suit('pin', 7),
  b.suit('pin', 8),
  b.suit('sou', 5),
];

const wall = [
  b.suit('man', 2),
  b.suit('pin', 5),
  b.suit('sou', 5),
  b.suit('man', 5),
  b.suit('pin', 2),
  b.suit('sou', 4),
];

export const lesson5Chi: LessonScript = {
  id: 'lesson-5-chi',
  titleKey: 'lesson.script.chi.title',
  deal: { hands: [human, seat1, seat2, seat3], wall },
  steps: [
    {
      instructionKey: 'lesson.script.chi.intro',
      expectedAction: { kind: 'info' },
      highlightTileIds: [sou2.id, sou3.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.chi.discard',
      expectedAction: { kind: 'discard', tileId: white.id },
      highlightTileIds: [white.id],
      autoAdvance: true,
    },
    { instructionKey: 'lesson.script.chi.reading', expectedAction: { kind: 'info' }, autoAdvance: false },
    { instructionKey: 'lesson.script.chi.claim', expectedAction: { kind: 'claim', claim: 'chi' }, autoAdvance: true },
    { instructionKey: 'lesson.script.chi.done', expectedAction: { kind: 'info' }, autoAdvance: false },
  ],
};
